'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'FormattedReactMessage',

  mixins: [_utils.I18nCommonMixin],
  propTypes: _utils.commonPropTypes,

  getMessage: function getMessage() {
    var options = this.props.options || {};
    if (!_I18n2.default.langEnabled && !_I18n2.default.publicPage) {
      _I18n2.default.debugLog("Forcing translation in English, lang is not enabled");
      options.locale = 'en';
    }

    return _I18n2.default.lookup(this.props.message, options);
  },
  getEscapedParam: function getEscapedParam(param, key) {
    if (!_react2.default.isValidElement(key)) {
      return _I18n2.default.escapeParam(param, key);
    }

    return _react2.default.cloneElement(key, {
      key: key,
      ref: param.ref
    });
  },
  renderFormattedMessage: function renderFormattedMessage() {
    return _I18n2.default.interpolateToArray(this.getEscapedParam, this.getMessage(), this.props.options);
  },
  render: function render() {
    var props = (0, _utils.getPassThroughProps)(this.props);
    return _react2.default.createElement(
      'span',
      props,
      this.renderFormattedMessage()
    );
  }
});
module.exports = exports['default'];